import { Faq } from '@boltenergy-be/design-system'
import Link from 'components/link/Link'
import { Trans, useTranslation } from 'next-i18next/pages'
import { routes } from 'utils/routes'
import { useRouter } from 'next/router'
import { mapCmsFaqArticleToAccordionItem, mapFaqCategoryToFaqSection } from 'utils/cms'
import { FaqWithDefaultDescriptionProps } from './types'

const FaqWithDefaultDescription = ({ categories, ...props }: FaqWithDefaultDescriptionProps) => {
  // Router
  const { locale } = useRouter()

  // i18n
  const { t } = useTranslation()

  return Array.isArray(categories) ? (
    <Faq
      description={<Trans t={t} i18nKey="faq.description" components={[<Link variant="inline" href={routes(locale).faq} />]} />}
      sections={categories.map((cat) => mapFaqCategoryToFaqSection(cat))}
      {...props}
    />
  ) : (
    <Faq
      description={<Trans t={t} i18nKey="faq.description" components={[<Link variant="inline" href={routes(locale).faq} />]} />}
      articles={categories.articles.map(mapCmsFaqArticleToAccordionItem)}
      {...props}
    />
  )
}

export default FaqWithDefaultDescription
